export default __webpack_public_path__ + "4028bf9b9e23b21c740651a8b4df8611.jpg";